import { HttpClient } from '@angular/common/http';
import { Component, HostBinding, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import $ from 'jquery';
import { Team, TeamMember } from '../../app.models';
import { AppService } from '../../app.service';
import { ApplicationInsightsService } from '../../application-insights.service';
import { DescriptionService } from '../../services/description.service';
import { TypeDescriptionReportService } from '../../services/type-description-report.service';

import { CommonModule } from '@angular/common';
import { ViewChild } from '@angular/core';
import { TeamReportService, TeamReportStatus } from '../../services/team-report.service';

@Component({
  selector: 'profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class ProfileHeaderComponent implements OnInit {
  Http: HttpClient;
  teamInfo: Team;
  initials: string = '';
  name: string;
  description: string;
  mbtiType: string;
  isTeamView: boolean;
  isTeamMemberView: boolean = false;
  teamMember: TeamMember;
  downloadTeamReportUrl: string = '#';

  isReportDownloadButtonActivated: boolean = true;
  isReportDownloadButtonClicked: boolean = false;
  isTeamReportDownloadButtonActivated: boolean = true;
  assessmentBaseUrl: string;

  // Default circle color to teal with no border
  initialsColor: string = '#00c5c7';
  initialsBorder: string = 'unset';

  isComplete: boolean = true;
  isSelf: boolean = true;
  isMemberImported: boolean = false;
  showIndividual: boolean = false;

  @ViewChild('editTeamMemberModal') private editTeamMemberModalHandle: TemplateRef<NgbModalRef>;

  // Set :host background styles in parent container dynamically
  @HostBinding('style.background') background: string;

  // When is the header dark?  When you are not on a profile page (Individual profile, Individual Team Member profile, Team Profile( page)
  darkBackground: boolean = false;

  blob: Blob;

  constructor(
    private appService: AppService,
    private http: HttpClient,
    public router: Router,
    private descriptionService: DescriptionService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private applicationInsightsService: ApplicationInsightsService,
    private typeDescriptionReportService: TypeDescriptionReportService,
    private teamReportService: TeamReportService,
  ) {
    this.Http = http;
  }

  ngOnInit() {
    this.appService.getUserDetails().subscribe({
      next: (data) => (this.assessmentBaseUrl = data.assessmentSiteBaseUrl),
      error: (err) => this.appService.handleError(err),
    });

    if (this.router.url.includes('/team')) {
      // Team View
      this.isTeamView = true;
      this.darkBackground = true;

      this.teamInfo = this.appService.getTeamInfo();
      this.name = this.teamInfo.teamName;
      this.mbtiType = this.teamInfo.teamMbtiType;
      this.isComplete = !this.teamInfo.teamMbtiType ? false : true;

      if (this.isComplete) {
        this.description = this.descriptionService.teamDescription(this.mbtiType);
      } else {
        this.description = 'All team members must complete assessments to unlock team type.';
      }
      let id = +this.route.snapshot.paramMap.get('id');

      if ($.isNumeric(id) && id > 0 && id <= this.teamInfo.teamMembers.length + 1) {
        // Individual Team Member View
        this.darkBackground = false;
        this.isTeamView = false;
        this.isTeamMemberView = true;
        this.showIndividual = true;
        this.isComplete = true;

        try {
          this.teamMember = this.teamInfo.teamMembers.find((obj) => {
            return obj.memberId === id;
          });
          this.isSelf = this.teamMember.currentUser === true;
          this.name = this.teamMember.firstName + ' ' + this.teamMember.lastName;
          this.mbtiType = this.teamMember.mbtiType;
          this.description = this.descriptionService.individualDescription(this.teamMember.mbtiType);
          this.initials = this.teamMember.initials;
          this.initialsColor = this.teamMember.color;
          // Too hard to see yellow on yellow, so add a border color when member color is yellow
          this.initialsBorder = this.teamMember.color === '#FABB2A' ? '1px solid #929694' : 'unset';
          this.isMemberImported = this.teamMember.isImported;
        } catch (exception) {
          // Log error and take user back to error page
          this.applicationInsightsService.logException(exception);
          this.router.navigate(['/error']);
        }
      }

      if (this.router.url === '/team/profile') {
        // If Team profile, then white background and hide seeTeamProfile button
        this.darkBackground = false;
      }
    } else {
      // Your Results
      var currentUser = this.appService.getCurrentTeamMember(); //can return null or undefined
      if (currentUser) this.isMemberImported = currentUser.isImported;
      this.isTeamView = false;
      this.darkBackground = false;
      this.showIndividual = true;

      this.initials = this.appService.initials;
      this.name = this.appService.firstName + ' ' + this.appService.lastName;
      this.mbtiType = this.appService.mbtiType;
      this.description = this.descriptionService.individualDescription(this.mbtiType);
    }

    if (!this.isComplete) {
      this.description = 'All team members must complete assessments to unlock team type.';
    }

    if (this.darkBackground) {
      this.background = '#5d40b0';
    } else {
      this.background = 'white';
    }
  }

  downloadTeamTypeReport() {
    this.checkTeamReportStatus();
  }

  openLearning() {
    this.Http.get('/api/session/partialsignout').subscribe(() => {
      //console.log("Successfully signed out.");
      window.location.href = this.assessmentBaseUrl + '/Results/SelectYourType';
    });
  }

  downloadYourTypeReport() {
    this.isReportDownloadButtonClicked = true;

    this.typeDescriptionReportService.GetReport().subscribe(
      (result) => {
        this.blob = new Blob([result], { type: 'application/octet-stream' });
        const downloadURL = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${this.appService.firstName}${this.appService.lastName}-${this.appService.mbtiType}.pdf`;
        link.click();
      },
      (error) => {
        this.appService.handleError(error);
      },
      () => {
        this.isReportDownloadButtonClicked = false;
      },
    );
  }

  checkTeamReportStatus() {
    this.isTeamReportDownloadButtonActivated = false;
    this.teamReportService.getTeamReport(this.teamInfo.teamId).subscribe({
      next: (request) => {
        switch (request.status) {
          case TeamReportStatus.available: {
            const URL = window.URL;
            const downloadUrl = URL.createObjectURL(request.file);
            try {
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.download = request.file.name;
              link.click();
            } catch (err) {
              this.appService.handleError(err);
            } finally {
              URL.revokeObjectURL(downloadUrl);
            }
            break;
          }
          case TeamReportStatus.isPending: {
            this.modalService.open(this.editTeamMemberModalHandle, { centered: true, windowClass: 'teamReportProcessingModal' });
            break;
          }
          case TeamReportStatus.incomplete:
          default: {
            this.handleTeamReportErrorStatus(request.status);
            break;
          }
        }
        this.isTeamReportDownloadButtonActivated = true;
      },
      error: (status: TeamReportStatus) => {
        this.handleTeamReportErrorStatus(status);
        this.isTeamReportDownloadButtonActivated = true;
      },
    });
  }

  isShowingEmptyState() {
    return this.appService.isShowingEmptyState();
  }

  unlock() {
    window.location.href = this.appService.assessmentSiteBaseUrl + '/Account/Logon';
  }

  private handleTeamReportErrorStatus(status: TeamReportStatus) {
    let err = '';
    switch (status) {
      case TeamReportStatus.authError: {
        err = 'Unable to access the team report.';
        break;
      }
      case TeamReportStatus.isPending: {
        err = 'The report cannot be downloaded yet because is still being generated.';
        break;
      }
      case TeamReportStatus.incomplete: {
        err = 'Some members of the team have not finished their assessment.';
        break;
      }
      case TeamReportStatus.unknown:
      default: {
        err = 'An unknown error occurred. Please try again later.';
        break;
      }
    }
    this.appService.handleError(err);
  }
}
